import FoodSliderCreate from '../../components/forms/food-management/create.form';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import CreateByGroupSlider from '../../components/tables/food-management/quantification-by-group.table';
import ManagePhysicalActivity from '../health-consulting-management/manage-physical-activity';

import FoodGroupManagementTable from '../../components/tables/food-management/food-management-quantity.table.tsx';
export default function ManagePhysicalActivityPermission() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <FoodSliderCreate />;
      case PermissionMode.EDIT:
        return <FoodSliderCreate />;
      case PermissionMode.CREATE_BY_LIST:
        return <CreateByGroupSlider />;
      case PermissionMode.QUANTIFICATION:
        return <FoodGroupManagementTable />;
      default:
        return <ManagePhysicalActivity />;
    }
  };
  return <>{renderContent()}</>;
}
